export const checkAllDayRange = (from: Date, to: Date): boolean => {
  const atMidnight = (date: Date): boolean => {
    return (
      date.getHours() === 0 &&
      date.getMinutes() === 0 &&
      date.getSeconds() === 0 &&
      date.getMilliseconds() === 0
    );
  };

  const msDay = 24 * 60 * 60 * 1000;
  const duration = to.getTime() - from.getTime();

  return atMidnight(from) && atMidnight(to) && duration >= msDay && duration % msDay === 0;
};
